import { render, staticRenderFns } from "./PersonManagement.vue?vue&type=template&id=701ee0fd&scoped=true"
import script from "./PersonManagement.vue?vue&type=script&lang=js"
export * from "./PersonManagement.vue?vue&type=script&lang=js"
import style0 from "./PersonManagement.vue?vue&type=style&index=0&id=701ee0fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701ee0fd",
  null
  
)

export default component.exports